module.exports = __webpack_public_path__ + "static/media/complete_control.c63a4b3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/complete_control.svg
// module id = 380
// module chunks = 0